/**
 * 对话框组件
 * @author wangdi
 */

/*===============================================================================================@

 ## 功能说明

 ### $Dialog.notify
 * param1: string > 显示字符串
 * param2: duration > ms
 * param3: icon > 图标 1、√  2、× 3、★
 *
 ### $Dialog.alert
 * param1: string > 显示字符串
 * param2: callback > 点击确认后的回调

 ### $Dialog.confirm
 * param1: string|{tip,confirm,cancel,style,width} > 显示字符串
 * param2: callback > 点击确认后的回调
 * param3: errCallback > 点击取消后的回调

 ### $Dialog.registerModal
 * param :
 > [ xxModal:{ } ]
 #### xxModal
 ```
 $Dialog.registerModal({
 submitModal:{
 target:'#submitModal',
 transMtd:'Z-modal_show'
 }
 });
 ```
 #### $Dialog.xxModal( 'show'| 'hide' )


 @==============================================================================================*/

// 外部依赖
import $wd from '../../utils';

// 添加CSS样式
require("./assets/css/dialog.scss");

let messageBoxAlertTemplate = require("./assets/views/message-box-alert.html");
let messageBoxConfirmTemplate = require("./assets/views/message-box-confirm.html");

// HTML 模板
let htmlTemplate = {
    createElemByHtml: function (str) {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = str;
        if (tempDiv.childElementCount <= 0) {
            return null;
        } else if (tempDiv.childElementCount == 1) {
            return tempDiv.children[0];
        }
        return tempDiv.children;
    },
    getAlertElem: function () {
        return this.createElemByHtml(messageBoxAlertTemplate);
    },
    getConfirmElem: function () {
        return this.createElemByHtml(messageBoxConfirmTemplate);
    }
};

/**
 * 警告对话框
 * <button class="btn btn-success btn-sm" onclick="$Dialog.alert('我是一个警告对话框！~\(≧▽≦)/~')">点击试下</button>
 * @param {string|{tip,confirm}} str 提示信息，字符串类型为提示文本，对象类型如下
 * @param {string|{tip,confirm}} str.tip 提示文本
 * @param {string|{tip,confirm}} str.confirm 确认按钮文本
 * @param {function=} callback 点击确认后的回调函数
 * @memberof module:DialogBox
 */
function alert(str, callback) {
    let alertElem = htmlTemplate.getAlertElem();
    if (typeof str == "string") {
        alertElem.querySelector('.confirm-content').innerHTML = str;
    }
    if (typeof str == "object") {
        alertElem.querySelector('.confirm-content').innerHTML = str.tip;
        alertElem.querySelector('[data-name="confirm"]').innerHTML = str.confirm;
    }

    alertElem.style.display = "block";
    document.body.appendChild(alertElem);
    setTimeout(function () {
        $wd(alertElem).addClass("active");
    },1);

    alertElem.querySelector('.selected').onclick = function () {
        // 确认
        callback && callback();
        $wd(alertElem).removeClass("active");
        setTimeout(function () {
            alertElem.parentNode.removeChild(alertElem);
        },300);
    }
}

/**
 * 确认对话框
 * <button class="btn btn-success btn-sm" onclick="$Dialog.confirm('我是一个确认对话框！~\(≧▽≦)/~')">点击试下</button>
 * @param {string|{tip,confirm,cancel,style,width}} str 提示信息，字符串类型为提示文本，对象类型如下
 * @param {string} [str.tip="提示信息"] 提示文本
 * @param {string} [str.confirm="确定"]确认按钮文本
 * @param {string} [str.cancel="取消"] 取消按钮文本
 * @param {string} [str.style=""] 附加样式
 * @param {function=} confirmCallback 点击确认后回调函数
 * @param {function=} cancelCallback 点击取消后回调函数
 * @memberof module:DialogBox
 */
function confirm(str, confirmCallback, cancelCallback) {
    let alertElem = htmlTemplate.getConfirmElem();
    let textElem = alertElem.querySelector('.confirm-content');
    alertElem.querySelector('.confirm-content').innerHTML = str;
    if (typeof str == "string") {
        alertElem.querySelector('.confirm-content').innerHTML = str;
    }
    if (typeof str == "object") {
        textElem.innerHTML = str.tip;
        alertElem.querySelector('[data-name="confirm"]').innerHTML = str.confirm ? str.confirm : "确认";
        alertElem.querySelector('[data-name="cancel"]').innerHTML = str.cancel ? str.cancel : "取消";
        textElem.setAttribute('style', (textElem.getAttribute('style') || "") + (str.style || ""));
        if (str.width) {
            alertElem.querySelector('.confirm').style.width = str.width;
        }
    }
    alertElem.style.display = "block";
    document.body.appendChild(alertElem);

    // $wd(alertElem).addClass("active");
    setTimeout(function () {
        $wd(alertElem).addClass("active");
    },1);

    function hide() {
        $wd(alertElem).removeClass("active");
        setTimeout(function () {
            alertElem.parentNode.removeChild(alertElem);
        },300);
    }

    alertElem.querySelector('#dialogButton0').onclick = function () {
        // 取消
        cancelCallback && cancelCallback();
        hide();
    };

    alertElem.querySelector('#dialogButton1').onclick = function () {
        // 确认
        confirmCallback && confirmCallback();
        hide();
    };
    return textElem;
}

var $messageBox = {
    alert: alert,
    confirm: confirm
};

// 接口函数集中调度
$wd.invokeProxy($messageBox, function () {
    return true;
});

export default $messageBox;